import React from 'react'
import { UsersAdmin } from 'src/core/models'
import UserAdminSeeDetails from './UserAdminSeeDetails/UserAdminSeeDetails'
import UserAdminRejectButton from './UserAdminRejectButton/UserAdminRejectButton'
import UserAdminValidateButton from './UserAdminValidateButton/UserAdminValidateButton'

const UserAdminListActions: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  return <div className='has-text-centered'>
    {/* Details */}
    <UserAdminSeeDetails user={user} />
    {/* Validate User */}
    <UserAdminValidateButton user={user} />
    {/* Reject User */}
    <UserAdminRejectButton user={user} />
  </div>
}

export default UserAdminListActions
